export default __webpack_public_path__ + "static/media/blueArrowIcon.1b31cb68.svg";